const keyConfig = {
  TAB: "TAB",
  ARROWUP: "ARROWUP",
  BACKTAB: "BACKTAB",
  ESCAPE: "ESCAPE",
  ARROWDOWN: "ARROWDOWN",
}

export default keyConfig
